import React from 'react';

export default function Loader({ height }) {
  return (
    <div className="loader__wrap loader--blur" style={{ height }}>
      <div className="loader" />
    </div>
  );
}
